<div class="layout-wrapper ">
  <div class="layout-wrapper-inner vh-100 overflow-hidden">

    <div class="layout-body d-flex h-100">
      <div *ngIf="showSideMenu" class="z2">
        <app-sidemenu></app-sidemenu>
      </div>
        <div class="right-content flex-fill">
          <app-layout-header *ngIf="showMainHeader"></app-layout-header>
        <div
          class="right-side-component"
          [ngStyle]="
            main.iscommercial === 2
              ? { background: '#E4EEE8' }
              : main.iscommercial === 1
              ? { background: '#DFE5ED' }
              : main.iscommercial === 0 || main.iscommercial === 3
              ? { background: 'rgb(248, 248, 248)' }
              : { background: '#f2f5f8' }
          "
        >
          <router-outlet></router-outlet>
          <!-- <img class="chat_img2 cursor" src="assets/images/img/chat_bubble.svg" alt="" (click)="show_chat();"> -->
            <!-- <div class="bottom-bar" [ngStyle]="{'display' : this.showChat ? 'unset' : 'none'}">
              <iframe                               
                [src]="this.chatUrl"
                width="400px"
                height="600px"
                frameborder="0"
                title="Chatbot"
                id="chatbotIframe"
              ></iframe>   
            </div> -->
        </div>
      </div>
    </div>
    <app-notifications></app-notifications>
  </div>
</div>